import type { FunctionComponent } from 'react';

import type { MemberEntity } from './types';

import * as styles from './Member.module.less';

type MemberProps = Pick<MemberEntity, 'text'>;

// TODO: Member popover on click

export const Member: FunctionComponent<MemberProps> = ({ text }) => {
  return (
    <span className={styles.inlineMember}>
      <span className={styles.fontWeightBold}>{text}</span>
    </span>
  );
};
